import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import {
  Button, IconGlobeCursor, IconSearch, TextField,
} from 'gatorcomponents';
import NavBar from '@/media/onboarding/navbar.svg';
import React, { useCallback } from 'react';
import * as Styles from './SearchDomain.styles';
import { List } from '../List';

const SearchDomain = ({
  searchLocales,
  listLocales,
  buttonsProps,
  domainsList,
  freeDomains,
  searchDomain,
  searchLoading,
  result,
  checkedItems,
  setCheckedItems,
  handleBuyDomain,
  loading,
  domain,
  searchedDomain,
  setDomain,
}) => {
  const genericStepProps = useCallback(() => ({
    testId: 'buy-domain-search-domain',
    buttonsProps: {
      ...buttonsProps,
      rightButton: {
        ...buttonsProps.rightButton,
        disabled: loading || !checkedItems.length,
        onClick: handleBuyDomain,
        loading,
      },
    },
    contentWidthFlexible: true,
    centerContent: false,
  }), [buttonsProps, checkedItems, handleBuyDomain, loading]);

  const handleChangeDomain = useCallback((e) => {
    setDomain(e.target.value);
  }, [setDomain]);

  const handleSearchDomain = useCallback((e) => {
    e.preventDefault();
    searchDomain && searchDomain({ domain });
  }, [domain, searchDomain]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      handleBuyDomain();
    }
  }, [handleBuyDomain]);

  return (
    <GenericStep {...genericStepProps()}>
      <Styles.Wrapper data-testid="enter-domain-step">
        <IconGlobeCursor color="primaryMedium" size="md" />
        <Styles.Title>{searchLocales.title}</Styles.Title>
        <Styles.Description>
          {searchLocales.description}
        </Styles.Description>
        <Styles.NavWrapper>
          <Styles.NavbarContainer>
            <Styles.NavbarImage src={NavBar} />
          </Styles.NavbarContainer>
          <Styles.DomainForm onSubmit={handleSearchDomain}>
            <TextField
              name="domain"
              testId="input-domain"
              label={searchLocales.inputLabel}
              onChange={e => handleChangeDomain(e)}
              onKeyDown={e => handleKeyDown(e)}
              value={domain}
            />
            <Styles.ButtonWrapper>
              <Button
                testId="search-domain-button"
                label=""
                disabled={!domain || searchLoading}
                loading={searchLoading}
                iconRight={searchLoading ? null : <IconSearch size="lg" />}
                size="medium2"
                type="submit"
              />
            </Styles.ButtonWrapper>
          </Styles.DomainForm>
        </Styles.NavWrapper>
        <Styles.Offer>{searchLocales.offer}</Styles.Offer>
      </Styles.Wrapper>
      <List
        domainsList={domainsList}
        freeDomains={freeDomains}
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
        locales={listLocales}
        searchedDomain={searchedDomain}
        available={result.available}
      />
    </GenericStep>
  );
};

export default SearchDomain;
